import { Button as ChakraButton, ButtonProps } from '@chakra-ui/react';

interface ButtonPropsInterface extends ButtonProps {
  href?: string;
  equalIconSpace?: boolean;
}

const Button = ({
  children,
  rightIcon,
  leftIcon,
  href = '',
  equalIconSpace = true,
  isLoading,
  ...rest
}: ButtonPropsInterface) => {
  const isIconExist = rightIcon || leftIcon;
  const contentCenter = isIconExist ? 'space-between' : 'center';

  const buttonStyles = {
    svg: {
      marginEnd: rightIcon ? 0 : 3,
      marginStart: rightIcon ? 3 : 0
    }
  };

  const buttonEqualStyles = {
    svg: {
      '&:nth-of-type(1)': {
        opacity: rightIcon ? 0 : 1,
        marginEnd: 3
      },
      '&:nth-of-type(2)': {
        opacity: leftIcon ? 0 : 1,
        marginStart: 3
      }
    }
  };

  return (
    <ChakraButton
      display='flex'
      justifyContent={contentCenter}
      w='100%'
      href={href}
      sx={equalIconSpace ? buttonEqualStyles : buttonStyles}
      isLoading={isLoading}
      {...rest}
    >
      {leftIcon || (equalIconSpace && isIconExist)}
      {children}
      {rightIcon || (equalIconSpace && isIconExist)}
    </ChakraButton>
  );
};

export default Button;
